export default (f, ms) => {
    let isExecuting = false

    return function cb(...args) {
        if (isExecuting) return

        f.apply(this, args)

        isExecuting = true

        setTimeout(() => {
            isExecuting = false
        }, ms)
    }
}
